import { render, staticRenderFns } from "./FixedRentalSettings.vue?vue&type=template&id=64fd802c"
import script from "@/scripts/modal/fixedRental/fixedRentalSettings.js?vue&type=script&lang=js&external"
export * from "@/scripts/modal/fixedRental/fixedRentalSettings.js?vue&type=script&lang=js&external"
import style0 from "./FixedRentalSettings.vue?vue&type=style&index=0&id=64fd802c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports